import axios from 'axios';
import { loginRequest } from '../authConfig';
import { msalInstance } from '../index';

axios.defaults.withCredentials = true;

export const client = axios.create({
  // baseURL: 'http://localhost:4000/api',
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Inject a fresh access token on every request so callers don't depend on a
// (possibly empty or stale) token stored elsewhere. MSAL refreshes the token
// silently when needed, which also avoids the first-login 401 race.
client.interceptors.request.use(
  async (config) => {
    try {
      const currentAccount = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
      if (currentAccount) {
        const accessTokenResponse = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account: currentAccount,
        });

        if (accessTokenResponse.accessToken) {
          config.headers.Authorization = `Bearer ${accessTokenResponse.accessToken}`;
          config.headers.version = '1.0.3';
        }
      }
    } catch (err) {
      console.error(err);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const getMonitoringImageNames = async (group) => {
    try {
      const response = await client.get(
        `/data/monitoring/imageNames?group=${group}`
      );
      return response.data ?? [];
    } catch (err) {
      throw new Error(err.response?.data?.err ?? err.message);
    }
  };

  export const getMonitoringLatestImageName = async (group) => {
    try {
      const response = await client.get(
        `/data/monitoring/latestImageName?group=${group}`
      );
      return response.data ?? [];
    } catch (err) {
      throw new Error(err.response?.data?.err ?? err.message);
    }
  };

  export const getMonitoringImageBlob = async (group, name) => {
    try {
      const response = await client.get(
        `/data/monitoring/imageBlob?group=${group}&name=${name}`
      );
      return response.data ?? [];
    } catch (err) {
      throw new Error(err.response?.data?.err ?? err.message);
    }
  };